<template>
  <div class="recommend-block-plus" v-if="dataList">
    <div class="inner-wrap">
      <div
        class="recommend-item"
        v-for="(item, idx) in dataList"
        :key="idx"
      >

        <!-- 特集リスト -->
        <div class="sec-inner feature-list" v-if="+item.type === 0">
          <div class="sec-title" :style="{color: colorScheme.keyColor}" v-html="item.title[0]"></div>
          <div class="features-banner-wrap" v-if="!!item.image && item.image.length > 0">
            <a
              class="features-banner"
              :class="{'no-link': !item.url}"
              :href="item.url"
              @click.prevent="onBannerClick($event, item)"
            ><img :src="item.image" :alt="item.title"></a>
          </div>
          <sec-features-list  :list-data="item" />
        </div>

        <!-- テキストリンク -->
        <div class="sec-inner text-link" v-else-if="+item.type === 6" :style="{marginBottom: idx === 1 ? '20px' : 0}">
          <!-- 下部マージンは二個目の要素に固定になるので、要注意。テキストリンクをグループ化しないとだめ -->
          <a
            :href="item.url"
            @click.prevent="onTextlinkClick"
            v-html="item.titleArr[0]"
            :style="{
              color: colorScheme.keyColor,
              borderColor: colorScheme.keyColor
            }"></a>
          <arrow-std-recommend class="arrow" :base-color="colorScheme.keyColor" />
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import SecFeaturesList from '@/utvStore/components/Toppage/section/SecFeaturesList'
import ArrowStdRecommend from "./icon/ArrowStdRecommend";

export default {
  name: 'RecommendBlockPlus',
  components: {
    ArrowStdRecommend,
    SecFeaturesList,
  },
  props: {
    recommendData: {
      type: Array,
    },
    colorScheme: {
      type: Object,
      default: {
        keyColor: 'black',
      }
    }
  },
  computed: {
    dataList() {
      if(!!this.recommendData && this.recommendData.length > 0) {
        return this.recommendData
          .filter(item => +item.type === 6
            || +item.type === 0)
          .map(item => {
            const arr = []
            if (!!item.title && item.title.length > 0) {
              if (typeof item.title === 'string') {
                arr.push(item.title)
              } else {
                arr.push(...item.title)
              }
            }
            return {
              ...item,
              titleArr: arr.length > 0 ? arr : null,
            }
          })
      }
    },
  },
  mounted() {
  },
  methods: {
    onTextlinkClick(e) {
      // TODO: is_externalの処理
      location.href = e.target.href
    },
    onBannerClick(e, data) {
      // TODO: is_externalの処理
      location.href = data.url
    },
  }
}</script>

<style scoped lang="scss">
.recommend-block-plus {
  padding: 32px 0 64px;
  background: white;
  .inner-wrap {
    .sec-inner {
      width: 100%;

      &.text-link {
        position: relative;
        padding: 0 20px;
        a {
          display: block;
          padding: 16px 20px;
          border-bottom: 1px solid;
          font-size: 14px;
          font-weight: bold;
          text-decoration: none;
        }
        .arrow {
          display: block;
          position: absolute;
          top: 0;
          bottom: 0;
          right: 34px;
          margin: auto;
        }
      }

      .sec-title {
        padding: 16px 20px 4px;
        font-size: 18px;
        font-weight: bold;
      }

      .sec-lucky7 {
        padding-top: 0;
      }
      .features-banner-wrap {
        width: 100%;
        padding: 0 24px;
        margin-bottom: 20px;
        .features-banner {
          width: 100%;
          display: block;
          cursor: pointer;
          user-select: none;
          &.no-link {
            pointer-events: none;
          }
          img {
            width: 100%;
            display: block;
            user-select: none;
          }
        }
        .counselor-list {
          width: 100%;
          background: white;
          padding: 16px;
          border-radius: 10px;
          .list-wrap {
            width: 100%;
            display: flex;
            justify-content: space-around;
            align-items: center;
            .counselor-item {
              width: 25%;
              display: block;
              cursor: pointer;
              user-select: none;
              flex-shrink: 1;
              margin-right: 8px;

              &:last-child {
                margin-right: 0;
              }

              img {
                width: 100%;
                display: block;
                user-select: none;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/common/RecommendBlockPlus.vue